export enum Environment {
  Local = 'local',
  // LocalUtveckling = fsok-next locally, using legoasutv01 as backend
  LocalUtveckling = 'localUtveckling',
  Utveckling = 'utveckling',
  Acceptans = 'acceptans',
  Stage = 'stage',
  Prod = 'prod',
}
